import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ThemeService } from '../../../../_helpers/theming-engine/theme.service';
import { BaseLearningSectionComponent } from '../../../../shared/learning-section/base-learning-section/base-learning-section.component';
import { LearningSectionFlowControlHelperService } from '../../../../_helpers/learning-section-flow-control-helper/learning-section-flow-control-helper.service';
import { StudentOutcome } from '../../../../_models';
import { TutorReportsHelperService } from '../../../../_helpers/tutor-reports-helper/tutor-reports-helper.service';

@Component({
    selector: 'classic-progress-section',
    templateUrl: './classic-progress-section.component.html',
    styleUrls: ['./classic-progress-section.component.css'],
    standalone: false
})
export class ClassicProgressSectionComponent extends BaseLearningSectionComponent implements OnInit {
  @Input() timelineSection: StudentOutcome = new StudentOutcome();

  // Lookup-backed display texts: getters (not init-time fields) so they resolve once
  // TutorReportsHelperService.ensureContext() has loaded keyStages/targetGrades.
  public get keyStageText(): string {
    return this.tutorReportsHelperService.keyStages?.find(k => k.id == this.timelineSection.keyStage)?.description ?? '';
  }

  public get learningBandText(): string {
    return this.tutorReportsHelperService.targetGrades?.find(g => g.id == this.timelineSection.learningBand)?.text ?? '';
  }

  constructor(
    protected readonly flowHelperService: LearningSectionFlowControlHelperService,
    public dialog: MatDialog,
    public themeService: ThemeService,
    private tutorReportsHelperService: TutorReportsHelperService
  ) {
    super(flowHelperService, dialog);
    this.sectionTitle = 'Progress (Classic)';
  }

  ngOnInit() {
    
  }

}
